import React, { Component } from 'react'
import styled from 'styled-components'

const Item = styled.div`
  margin-left: 1.5vw;
  height: 2vw;
  font-family: OpensansLight;
  font-size: 0.7vw;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: ${props => {
    return props && props.tone === 'dark' ? 'gray' : 'white'
  }};
`
const MarkedItem = Item.extend`
  font-family: OpensansBold;
  color: ${props => {
    props && props.tone === 'dark' ? 'gray' : 'white'
  }};
`
const NavigationItem = ({ marked, label, tone, onClick }) => {
  if (marked) {
    return (
      <MarkedItem tone={tone} onClick={() => onClick()}>
        {label}
      </MarkedItem>
    )
  } else {
    return (
      <Item tone={tone} onClick={() => onClick()}>
        {label}
      </Item>
    )
  }
}

export default NavigationItem



// WEBPACK FOOTER //
// ./src/components/navigation-item.js